var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2344 3.99844V0H0.25V18H19.75V3.99844H10.2344ZM4.24375 15.9984H2.24687V13.9969H4.24375V15.9984ZM4.24375 12H2.24687V9.99844H4.24375V12ZM4.24375 8.00156H2.24687V6H4.24375V8.00156ZM4.24375 3.99844H2.24687V1.99687H4.24375V3.99844ZM8.2375 15.9984H6.24063V13.9969H8.2375V15.9984ZM8.2375 12H6.24063V9.99844H8.2375V12ZM8.2375 8.00156H6.24063V6H8.2375V8.00156ZM8.2375 3.99844H6.24063V1.99687H8.2375V3.99844ZM17.7531 15.9984H10.2344V13.9969H12.2313V12H10.2344V9.99844H12.2313V7.99688H10.2344V6H17.7531V15.9984ZM15.9906 8.00156H13.9938V10.0031H15.9906V8.00156ZM15.9906 12H13.9938V14.0016H15.9906V12Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.81f41c55c92574337c641569f00c648b.svg";
export { ForwardRef as ReactComponent };